module.exports = __webpack_public_path__ + "static/media/cww.531d605d.jpg";